import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import QuestionnairePreview from './QuestionnairePreview';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	questionnaireId: string;
	size?: Size;
}

const QuestionnairePreviewModal: React.FC<Props> = ({
	isOpen,
	onClose,
	questionnaireId,
	size = Size.FULLSCREEN,
}) => {
	const { isCase } = useTreatmentContext();
	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={size}>
			<Modal.Header title='component.questionnairePreview.title' />
			<Modal.Content contentScroll>
				<QuestionnairePreview questionnaireId={questionnaireId} />
			</Modal.Content>
		</Modal>
	);
};

export default QuestionnairePreviewModal;
